export default __webpack_public_path__ + "static/tema-atas-4a61f96471326bb27097d1ae7f61a56d.png";